<template lang="pug">
  .belgium
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/belgium-min.png"
      )
      span {{ gettext('Бельгия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content
      div
        p {{ gettext('Эта страна является членом Евросоюза, она довольно успешна в плане экономики, в ней часто происходят самые важные политические встречи мировых лидеров. Также она достаточно приветливо встречает иммигрантов, для получения гражданства в этой стране не нужно проходить длительную выматывающую процедуру, через 4 года пребывания в Бельгии по виду на жительство можно запрашивать гражданство. Но такое лояльное отношение касается только трудовых мигрантов, которые готовы работать на благо бельгийской экономики и науки.') }}
        p {{ gettext('Бельгия славится своей великолепной архитектурой, соединяющей множество разных стилей, цветов и форм. Там кипит культурная и образовательная жизнь, есть много университетов с мировым именем, музеев, галерей, театров. Также бережно и уважительно бельгийцы относятся к своей природе. В Бельгии три официальных языка - немецкий, французский и нидерландский.') }}
        p {{ gettext('Такая развитая и богатая страна поддерживает своё положение благодаря развитии сфер машиностроения и оборудования, химической индустрии, металлургии, алмазного производства, сельского хозяйства, производства продуктов питания и туризма.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
      div
        .about-boxes
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/visa-rules`")
            span {{ gettext('Visa rules') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/working-conditions`")
            span {{ gettext('Working conditions') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/accommodation`")
            span {{ gettext('Accommodation') }}
          router-link.box.horizontal-hover(:to="`/${getLanguage}/` + country + `/healthcare`")
            span {{ gettext('Healthcare') }}

</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/belgium-min.png'})
  },
  name: 'Belgium',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Belgium | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/belgium/index.vue